import _ from 'lodash'
import type { AppUnitType } from '../../../shared/domain/units/types.no-deps'

export function sortedUnitTypes(unitTypes: AppUnitType[], allUnitTypes: AppUnitType[]) {
    // Sort the unit types so that they are ordered from parents to children. This might mean two
    // unrelated parents appear first and then their mutual children. We sort but figuring out all
    // the parents of each type and then making sure that a child type is considered 'less than' a
    // parent type.
    const getUnitTypeParentsIds = (a: AppUnitType): number[] => {
        if (a.parents.length) {
            const parents = a.parents.map((id) => allUnitTypes.find((unitType) => unitType.id === id))
            return _.concat(a.parents, _.flatten(parents.map(getUnitTypeParentsIds)))
        } else {
            return []
        }
    }

    const compareUnitTypes = (a: AppUnitType, b: AppUnitType) => {
        const aParents = getUnitTypeParentsIds(a)
        const bParents = getUnitTypeParentsIds(b)
        if (aParents.includes(b.id)) {
            return 1
        } else if (bParents.includes(a.id)) {
            return -1
        } else {
            return 0
        }
    }

    const orderedUnitTypes = [].concat(unitTypes)

    orderedUnitTypes.sort(compareUnitTypes)

    return orderedUnitTypes
}
